import { useEffect, useState } from 'react';
import {
    regions,
    timeZoneLocationMap,
} from 'flow/constants/region-lookup/login-data';
import { RegionType } from 'flow/types/region-lookup/UserRegion';

interface AppTimeZoneProps {
    timezone: string | null;
    offsetMinutes: number | null;
    location: RegionType;
}

const mapTimeZoneToLocation = (timezone: string | null): RegionType => {
    if (!timezone) {
        return regions.DEFAULT;
    }
    const location = timeZoneLocationMap[timezone];
    return location || regions.DEFAULT;
};

export const useAppTimezone = (): AppTimeZoneProps => {
    const [timezonePropData, setTimezonePropData] = useState<AppTimeZoneProps>({
        timezone: null,
        offsetMinutes: null,
        location: regions.DEFAULT,
    });

    useEffect(() => {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const offset = new Date().getTimezoneOffset();
        const mappedLocation = mapTimeZoneToLocation(timezone);

        setTimezonePropData({
            timezone,
            offsetMinutes: offset,
            location: mappedLocation,
        });
    }, []);

    return timezonePropData;
};
